/* eslint-disable */
import React, { useEffect, useRef, useState } from 'react';
import Word from 'saur_ui_library/src/Atoms/Word/Word';
import { dateFr } from '../../utils/helper';
import {
  anyMeasuresFindForPiezometrySelected,
  datesFormatedForRequest,
  inputTextDate,
  piezometersDropdownlistComponent,
  radioButtonComponent,
  renderSwitchButtons,
  savePiezoParameter,
  warningMessageCss,
} from '../../utils/helpers/view/detailsHelper';
import { createGlobalStyle } from 'styled-components';
import ModernDatePicker from '../../components/common/component/ModernDatePicker';
import Button from 'saur_ui_library/src/Atoms/Input/Button/Button';
import EcpDetailBodyContainer from './EcpDetailBodyContainer';
import ActiveSurfaceChart from './ActiveSurfaceChart';
import { EcpDetailApi, PiezometryApi } from '../../utils/api';
import { fetchPov } from '../DetailHelper';
import {
  calculatePartsForPieGraphic,
  createDateForMonthlyGraphic,
  dataGroupedByTypeOrDate,
  formatedDataForDailyAndMonthlyGraphics,
  formatedPluvioDataForDailyAndMonthlyGraphics,
  getUniqueTypeValues,
  initDates,
  prepareTableData,
  sum,
  sumByType,
} from '../../utils/helpers/view/ecpDetailHelper';
import { piezoPluvioInterface } from '../H2SParam/Interface';
import { getPiezoIds, getPiezoParameter, verifyPluvioAndPiezoData } from '../../utils/helpers/view/prMrDetailHelper';
import { Toast } from 'primereact/toast';

interface TabProps {
  id: number;
  label: string;
  active: boolean;
}

interface ECPDetailProps {
  row: any;
  IsVisible: boolean;
}

const ECPDetail = (props: ECPDetailProps) => {
  const [pluvioStatus, setPluvioStatus] = useState(false);
  const [piezoStatus, setPiezoStatus] = useState(false);
  // datepicker
  const [startDate, setStartDate] = useState<any>(null);
  const [endDate, setEndDate] = useState<any>(null);
  // show or hide tabs
  const [tabsStates, setTabsStates] = useState<TabProps[]>([
    { id: 0, label: 'Au point limite', active: true },
    { id: 1, label: 'Bassin de collecte', active: false },
    { id: 2, label: 'Surface active', active: false },
  ]);
  // data for line and histogramme charts
  const [dailyLimitPointData, setDailyLimitPointData] = useState<any>(null);
  const [monthlyLimitPointData, setMonthlyLimitPointData] = useState<any>(null);
  const [dailyCollectionPoolData, setDailyCollectionPoolData] =
    useState<any>(null);
  const [monthlyCollectionPoolData, setMonthlyCollectionPoolData] =
    useState<any>(null);
  // pluvio data
  const [pluvioMonthlyData, setMonthlyPluvioData] = useState<any>([]);
  const [pluvioDailyData, setDailyPluvioData] = useState<any>([]);
  // piezo data
  const [piezoDailyData, setDailyPiezoData] = useState<any>([]);
  // data for pie chart
  const [pieLimitPointData, setLimitPointPieData] = useState<any>(null);
  const [pieCollectionPoolData, setCollectionPoolPieData] = useState<any>(null);
  // data for tables
  const [tableLimitPointData, setLimitPointTableData] = useState<any>(null);
  const [tableCollectionPoolData, setCollectionPoolTableData] =
    useState<any>(null);
  // data for ihm
  const [dataSelected, setDataSelected] = useState<any>(piezoPluvioInterface.filter((p) => p.id === 3)[0]);
  const [dataToAdd, setDataToAdd] = useState<any>(piezoPluvioInterface);
  const [showFilters, setShowFilters] = useState<boolean>(false);
  const [piezoSelected, setPiezoSelected] = useState<any>(null);
  const [piezoOptions, setPiezoOptions] = useState<any>(null);
  const [piezoParameter, setPiezoParameter] = useState<any>(null);
  // pluvie value
  const [pluvieValue, setPluvieValue] = useState<any>([]);
  const [idPov, setIdPov] = useState<string | null>(null);
  // toast
  const toastSucess = useRef<any>(null);
  const toastError = useRef<any>(null);

  const dailyDataLimitPoint = async (pRow: any, dates: any) => {
    let data: any = [],
      typeValues: any = [],
      dateValues: any = [],
      dataGroupedByDate: any = [],
      dataToShow: any = [];
    try {
      const response = await EcpDetailApi.getWaterDailyDataAtLimitPoint(
        pRow.Code,
        dates.startDate,
        dates.endDate,
      );
      data = formatedDataForDailyAndMonthlyGraphics(response.data);
      typeValues = getUniqueTypeValues(data, 'type');
      dateValues = getUniqueTypeValues(data, 'x');
      dataGroupedByDate = dataGroupedByTypeOrDate(
        dateValues,
        data,
      );
      dataToShow = sumByType(dataGroupedByDate, typeValues);
    } catch (e) {
      console.log('erreur', e);
    }
    setDailyLimitPointData(dataToShow);
    setMonthlyLimitPointData(createDateForMonthlyGraphic(data, typeValues));
  };

  const getPercentageDataAtLimitPoint = async (pRow: any, dates: any) => {
    let tableData: any = [],
      dataToShow: any = [];
    try {
      const response = await EcpDetailApi.getPercentageDataAtLimitPoint(
        pRow.Code,
        dates.startDate,
        dates.endDate,
      );
      dataToShow = calculatePartsForPieGraphic(response.data);
      tableData = prepareTableData(dataToShow);
      setPluvieValue(dataToShow.filter((d) => d.type === 'PLUVIO'));
      setLimitPointPieData(
        dataToShow.filter((x) => x.type !== 'VTOT' && x.type != 'PLUVIO' && x.value > 0),
      );
    } catch (e) {
      console.log('erreur', e);
      setLimitPointPieData([]);
    }
    setLimitPointTableData(tableData);
  };

  const dailyPluvioData = async (pRow: any, dates: any) => {
    let dataToShow: any = [],
      dataDateFormated: any = [],
      dateDateFormatedValues: any = [],
      sumByTypeForMonthlyData: any = [];
    try {
      const response = await EcpDetailApi.getDailyPluvioDataAtLimitPoint(
        pRow.Code,
        dates.startDate,
        dates.endDate,
      );
      dataToShow = formatedPluvioDataForDailyAndMonthlyGraphics(
        response.data,
      );
      dataDateFormated = dataToShow.map((d: any) => { return { ...d, dateFormated: new Date(d.x).toLocaleDateString('fr').slice(3) }});
      dateDateFormatedValues = getUniqueTypeValues(dataDateFormated, 'dateFormated');
      sumByTypeForMonthlyData = dateDateFormatedValues.map((date: any) => {
        let dataByType: any = dataDateFormated.filter((d) => date === d.dateFormated);
        if (dataByType.length !== 0) {
          return {
            ...dataByType[0],
            y: sum(dataByType, "y"),
            x: new Date(
              dataByType[0].dateFormated.split("/")[1],
              Number(dataByType[0].dateFormated.split("/")[0] - 1)
            ),
          };
        }
      });
    } catch (e) {
      console.log('erreur', e);
    }
    setDailyPluvioData(dataToShow);
    setMonthlyPluvioData(sumByTypeForMonthlyData);
    setPluvioStatus(true);
  };

  const dailyPiezoData = async (pCodes: string, dates: any, pPiezoCarto: any[]) => {
    let piezoList: any = [],
      piezoOptions: any = [];
    try {
      const response = await PiezometryApi.getMeasures(
        pCodes,
        dates.startDate,
        dates.endDate,
      );
      // prepare data for graphics
      if (response.status === 200 && response.data.length > 0) {
        piezoList  = response.data.reduce((acc, item) => {
          const measures = item.measures.map((d) => ({
            x: new Date(d.date),
            y: parseFloat(d.value),
            type: 'PIEZO',
          }));
          if (measures.length > 0) {
            acc.push({ code: item.code, measures });
          } else {
            acc.push({ code: item.code, measures: [] });
          }
          return acc;
        }, []);
        // keep order of piezoCarto data
        pPiezoCarto.forEach((p: any, i: number) => {
          piezoOptions.push( { 
            id: i, 
            label: p.WaterTableStationCode + ' (' + p.Distance.toLocaleString() + 'm)', 
            value: p.WaterTableStationCode 
          });
          if(piezoList.find((piezo) => piezo.code === p.WaterTableStationCode) === undefined){
            piezoList.push({ code: p.WaterTableStationCode, measures: [] });
          }
        });
      }
    } catch (e) {
      console.log('erreur', e);
    }
    setDailyPiezoData(piezoList);
    setPiezoOptions(piezoOptions);
    setPiezoStatus(true);
  };

  const dailyDataCollectionPool = async (pRow: any, dates: any) => {
    let data: any = [],
      typeValues: any = [],
      dateValues: any = [],
      dataGroupedByDate: any = [],
      dataToShow: any = [];
    try {
      const response = await EcpDetailApi.getWaterDailyDataCollectionPool(
        pRow.collectionPoolId,
        dates.startDate,
        dates.endDate,
      );
      data = formatedDataForDailyAndMonthlyGraphics(
        response.data,
      );
      typeValues = getUniqueTypeValues(data, 'type');
      dateValues = getUniqueTypeValues(data, 'x');
      dataGroupedByDate = dataGroupedByTypeOrDate(
        dateValues,
        data,
      );
      dataToShow = sumByType(dataGroupedByDate, typeValues);
    } catch (e) {
      console.log('erreur', e);
    }
    setDailyCollectionPoolData(dataToShow);
    setMonthlyCollectionPoolData(createDateForMonthlyGraphic(data, typeValues));
  };

  const getPercentageDataCollectionPool = async (pRow: any, dates: any) => {
    let tableData: any = [],
      dataToShow: any = [];
    try {
      const response = await EcpDetailApi.getPercentageDataCollectionPool(
        pRow.collectionPoolId,
        pRow.Code,
        dates.startDate,
        dates.endDate,
      );
      dataToShow = calculatePartsForPieGraphic(
        response.data,
      );
      tableData = prepareTableData(dataToShow);
      setCollectionPoolPieData(
        dataToShow.filter((x) => x.type !== 'VTOT' && x.type != 'PLUVIO' && x.value > 0),
      );
    } catch (e) {
      console.log('erreur', e);
      setCollectionPoolPieData([]);
    }
    setCollectionPoolTableData(tableData);
  };

  const getDataForGraphics = async (pRow: any, dates: any, pluvioDates: any) => {
    dailyDataLimitPoint(pRow, dates);
    dailyDataCollectionPool(pRow, dates);
    dailyPluvioData(pRow, pluvioDates);
    getPercentageDataAtLimitPoint(pRow, dates).then(() => {
      getPercentageDataCollectionPool(pRow, dates);
    });
    getPiezoIds(pRow.Code).then((piezoListItems) => {
      if(piezoListItems.length > 0) {
        dailyPiezoData(piezoListItems.map((p) => p.attributes.WaterTableStationCode).join(","), dates, piezoListItems.map((p: any) => p.attributes));
      } else {
        setDailyPiezoData([]);
        setPiezoOptions([]);
        setPiezoStatus(true);
      }
    });
    getPiezoParameter(pRow.Code).then((piezoParameter) => {
      if(piezoParameter !== undefined) {
        setPiezoParameter(piezoParameter);
        setPiezoSelected(piezoParameter.bssId === null ? null : piezoParameter.bssId);
      }
    });
  };

  useEffect(() => {
    initDates().then((dates) => {
      setStartDate(dates.start);
      setEndDate(dates.end);
      const datesFormated = datesFormatedForRequest(dates.start, dates.end);
      getDataForGraphics(
        props.row,
        datesFormated.dataDates,
        datesFormated.pluvioDates,
      );
    });
    fetchPov(props.row.Code).then((pov) => setIdPov(pov));
  }, []);

  useEffect(() => {
    if (pluvioStatus === true && piezoStatus === true) {
      setPluvioStatus(false);
      setPiezoStatus(false);
      // manage filters
      const updateFilters = verifyPluvioAndPiezoData(pluvioDailyData, piezoDailyData);
      setDataToAdd(updateFilters.interfaceValues);
      setShowFilters(updateFilters.showHideFilters);
    }
  }, [pluvioStatus, piezoStatus]);

  const launchRequests = () => {
    if (startDate !== null && endDate !== null) {
      // show loaders
      setDailyCollectionPoolData(null);
      setDailyLimitPointData(null);
      setMonthlyCollectionPoolData(null);
      setMonthlyLimitPointData(null);
      setDailyPluvioData(null);
      setMonthlyPluvioData(null);
      setDailyPiezoData(null);
      setLimitPointPieData(null);
      setCollectionPoolPieData(null);
      setLimitPointTableData(null);
      setCollectionPoolTableData(null);
      setShowFilters(false);
      setDataToAdd(piezoPluvioInterface);
      setPiezoSelected(null);
      setPiezoOptions(null);
      setPluvieValue([]);
      setDataSelected(piezoPluvioInterface.filter((p) => p.id === 3)[0]);
      const dates = datesFormatedForRequest(startDate, endDate);
      getDataForGraphics(props.row, dates.dataDates, dates.pluvioDates);
    }
  };

  return (
    <> 
      <Styles />
      <Toast id='toast-success' ref={toastSucess} />
      <Toast id='toast-error' ref={toastError} />
      {/* Header */}
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          paddingTop: '10px',
        }}
      >
        {/* Title : name of installation */}
        <div style={{ fontSize: '18px', fontWeight: 'bold' }}>
          <Word value={props.row.Description} variant='h5'></Word>
        </div>
      </div>
      {/* Menu */}
      <div
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          width: '100%',
          height: '11%',
        }}
      >
        {/* date pickers */}
        {<div style={{ display: tabsStates[2].active === false ? 'contents' : 'none' }}>
            <div style={{ display: 'inline-flex' }}>
              <div style={{ display: 'block', marginRight: '10px' }}>
                <Word value='Mois de début' />
                <ModernDatePicker
                  className='datePickFrom'
                  inputPlaceholder='Mois de début'
                  value={startDate}
                  shouldHighlightWeekends
                  formatInputText={() => {
                    return inputTextDate(startDate);
                  }}
                  locale={dateFr}
                  onChange={(date: any) => {
                    setStartDate(date);
                  }}
                />
              </div>
              <div style={{ display: 'block', marginRight: '10px' }}>
                <Word value='Mois de fin' />
                <ModernDatePicker
                  className='datePickFrom'
                  inputPlaceholder='Mois de fin'
                  value={endDate}
                  shouldHighlightWeekends
                  formatInputText={() => {
                    return inputTextDate(endDate);
                  }}
                  locale={dateFr}
                  onChange={(date: any) => {
                    setEndDate(date);
                  }}
                />
              </div>
            </div>
            {/* Search data */}
            <Button className={'button'} mode='basic' onClick={launchRequests}>
              <Word
                variant='span'
                textStyle='normalBold'
                value={'Rechercher'}
              />
            </Button>
            
            {/* POV Section */}
            <div
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
                gap: '10px',
                marginLeft: '30px',
              }}
            >
              <Word
                textStyle='normalReg'
                variant='span'
                value={idPov ? 'POV :' : ''}
              />
              <Word
                variant='span'
                textStyle='normalBold'
                value={idPov ? idPov.toString() : ''}
              />
            </div>

            {/* radio buttons */}
            <div style={{ width: '90vh', display: 'flex', justifyContent: 'space-around' }}>
              {radioButtonComponent(showFilters, dataToAdd, setDataSelected, warningMessageCss)}
            </div>
            {/* Piezometers dropdown list */}
            {piezometersDropdownlistComponent(piezoOptions, piezoSelected, setPiezoSelected, warningMessageCss, piezoDailyData !== null ? anyMeasuresFindForPiezometrySelected(piezoDailyData, piezoSelected) : false)}
            {piezoOptions !== null && piezoOptions.length > 0 &&
              <Button automatedTestId="button-submit" className="export-btn" onClick={() => savePiezoParameter(piezoSelected, piezoParameter, setPiezoParameter, toastSucess, toastError)} mode="plain">
                <Word variant="span" textStyle="normalBold" value="Paramétrer" />
              </Button>}

          </div>
        }

        <div
          style={{
            display: 'inline-flex',
            width: '100%',
            justifyContent: 'end',
          }}
        >
          {/* switch buttons */}
          {renderSwitchButtons(tabsStates, setTabsStates)}
        </div>
      </div>
      {tabsStates[2].active === false && <EcpDetailBodyContainer
        showTab={tabsStates[1].active === true ? tabsStates[1].active : tabsStates[0].active}
        dailyData={tabsStates[1].active === true ? dailyCollectionPoolData : dailyLimitPointData}
        pluvioDailyData={pluvioDailyData}
        piezoCode={piezoSelected}
        piezoDailyData={piezoDailyData}
        monthlyData={tabsStates[1].active === true ? monthlyCollectionPoolData : monthlyLimitPointData}
        pluvioMonthlyData={pluvioMonthlyData}
        pieData={tabsStates[1].active === true ? pieCollectionPoolData : pieLimitPointData}
        tableData={tabsStates[1].active === true ? tableCollectionPoolData : tableLimitPointData}
        dataSelected={dataSelected}
        tabType={tabsStates[1].active === true ? 'collectionPool' : 'limitPoint'}
      />}
      {/* Active surface chart  */}

      {tabsStates[2].active === true && (
        <ActiveSurfaceChart
          showTab={tabsStates[2].active}
          collectionPoolId={props.row.collectionPoolId}
        />
      )}
      <br />
    </>
  );
};

const Styles = createGlobalStyle`
.sds-reset-style{
  .loaderEcpGraphics {
    width: 48px;
    height: 48px;
    border: 5px solid #FFF;
    border-bottom-color: #243977;
    border-radius: 50%;
    display: inline-block;
    box-sizing: border-box;
    animation: rotation 1s linear infinite;
    }

    @keyframes rotation {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
  }
  .button {
    color: #232323;
    background-color: #63d1b5;
    font-size: 14px;
    line-height: 22px;
    text-align: center;
    border-radius: 25px;
    cursor: pointer;
    padding: 10px 20px;
  }
  .ecpVolTable {
    td:first-child {
      font-weight: bolder;
    }
    tr:last-child, tr:first-child {
      font-weight: bolder;
    }
    td {
      padding: 5px;
    }
  }
}
`;

export default ECPDetail;
